import { render, staticRenderFns } from "./TaskHistory.vue?vue&type=template&id=3dca764f&scoped=true"
import script from "./TaskHistory.vue?vue&type=script&lang=js"
export * from "./TaskHistory.vue?vue&type=script&lang=js"
import style0 from "./TaskHistory.vue?vue&type=style&index=0&id=3dca764f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dca764f",
  null
  
)

export default component.exports